<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-with-heading full-character-formatting" id="dedication">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">DEDICATION</h1>
</div>
</div>
</div>
</div>
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">Dedicated to Kevin McCormick,</p>
<p class="subsq dedication-content">“the most endangered species, the honest man.”</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?ac5e933c